export default __webpack_public_path__ + "static/Groupe741-tablet-1cc2f24144cdd00688dde22fc1680d53.webp";